import React, { useContext, useRef, useMemo } from 'react';

import { classNames } from 'primereact/utils';

import { UserDetailsContext } from 'context/userDetailsContext';
import { Tooltip } from 'primereact/tooltip';
import { GroupUserTooltip } from 'components/UI/GroupUserTooltip/GroupUserTooltip';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { titleCapitalize } from 'utils/utility_functions/titleCapitalize';
import AssignFirmUserResolution from '../AssignFirmUserResolution/AssignFirmUserResolution';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
function ConversationBetween({
  messageDetails,
  redirectToPage,
  fromSidebar,
  isLeadSpecific,
  selectedMessage,
  loadFirmUserList,
  firmUserList,
  fetchCaseMessageDetails,
}) {
  const userContext = useContext(UserDetailsContext);
  const op = useRef(null);

  // Combine original message_to with tag_in_message_to for complete conversation participants
  const allConversationParticipants = useMemo(() => {
    const originalParticipants = messageDetails?.message_to || [];
    const delegatedParticipants = messageDetails?.tag_in_message_to || [];

    // Combine and remove duplicates based on recipient_id
    const combined = [...originalParticipants, ...delegatedParticipants];
    const unique = combined.filter(
      (participant, index, self) => index === self.findIndex((p) => p.recipient_id === participant.recipient_id)
    );

    return unique;
  }, [messageDetails?.message_to, messageDetails?.tag_in_message_to]);

  const remainingFirmUsers = allConversationParticipants
    ?.filter((data) => data?.recipient_id !== userContext.firmDetails.current_user && data?.firm_user_id)
    .slice(2);

  const handleMoreClick = (e) => {
    op.current?.toggle(e); // Toggle the overlay panel when "more" is clicked
  };

  const handleModuleRedirectionForCurrentUser = () => {
    let currentUser = allConversationParticipants?.filter((data) => data?.firm_user_id === userContext?.firmDetails?.firm_user_id);
    let route = '/';

    if (currentUser?.length && currentUser[0]?.firm_user_id && currentUser[0]?.access_level !== 'client') {
      route = `/settings/team-management/${currentUser[0]?.firm_user_id}`;
    }

    return route;
  };

  const handleModuleRedirection = (data, type) => {
    let route = '/';

    if (type === 'group') {
      route = '/settings/groups';
    } else {
      if (data?.access_level === 'client') {
        route = data?.contact_id ? `/contacts/${data?.contact_id}` : '/contacts';
      } else if (data?.access_level !== 'client') {
        route = data?.firm_user_id ? `/settings/team-management/${data?.firm_user_id}` : '/settings/team-management';
      }
    }

    return route;
  };

  return !fromSidebar ? (
    <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3" style={{ rowGap: '1rem' }}>
      <div style={{ flex: '1 1 300px', minWidth: '250px', maxWidth: '100%' }}>
        <span className="F-size14">Conversation Between: </span>
        {allConversationParticipants?.filter((data) => data?.recipient_id === userContext.firmDetails.current_user)?.length > 0 && (
          <Link
            style={{ marginLeft: '0.5rem' }}
            className="F-size14 text-primary-dark text-decoration-none case-details-link pointer"
            to={() => handleModuleRedirectionForCurrentUser()}
          >
            You{', '}
          </Link>
        )}
        {messageDetails?.groups?.map((msg, index) => (
          <Link
            key={index}
            className={classNames({
              'F-size14 text-primary-dark text-decoration-none case-details-link pointer': true,
              'disabled-element': false,
              ['name-' + index]: true,
            })}
            to={() => handleModuleRedirection(msg, 'group')}
          >
            {`${msg?.group_name} (Group${msg?.status === 'ARCHIVED' ? ' - Archived' : ''})`}
            {index < messageDetails?.groups?.length - 1 ? ', ' : ''}
            <Tooltip target={`.name-${index}`} position="top">
              {GroupUserTooltip(msg, messageDetails?.message_to)}
            </Tooltip>
          </Link>
        ))}
        {allConversationParticipants?.filter(
          (data) => data?.recipient_id !== userContext?.firmDetails?.current_user && (data?.firm_user_id || data?.contact_id)
        )?.length > 0 &&
          messageDetails?.groups?.length > 0 &&
          ', '}

        {allConversationParticipants
          ?.filter((data) => data?.recipient_id !== userContext.firmDetails.current_user && (data?.firm_user_id || data?.contact_id))
          .map((msg, index) => (
            <Link
              key={index}
              className=" F-size14 text-primary-dark text-decoration-none case-details-link pointer class-tooltip"
              to={() => handleModuleRedirection(msg, 'user')}
            >
              <>
                {msg?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
                {msg?.first_name} {msg?.last_name} (
                {msg?.access_level === 'client' ? msg?.role || 'Client' : titleCapitalize(msg?.access_level)})
                {index <
                allConversationParticipants?.filter(
                  (data) => data?.recipient_id !== userContext?.firmDetails?.current_user && (data?.firm_user_id || data?.contact_id)
                )?.length -
                  1
                  ? ', '
                  : ''}
              </>

              {msg.status === 'ARCHIVED' && (
                <Tooltip
                  position="top"
                  target=".class-tooltip"
                  content={msg?.status?.toLowerCase()?.charAt(0)?.toUpperCase() + msg?.status?.slice(1)?.toLowerCase()}
                />
              )}
            </Link>
          ))}
      </div>

      <div>
        <AssignFirmUserResolution
          isLeadSpecific={isLeadSpecific}
          selectedMessage={messageDetails}
          loadFirmUserList={loadFirmUserList}
          firmUserList={firmUserList}
          fetchCaseMessageDetails={fetchCaseMessageDetails}
        />
      </div>
    </div>
  ) : (
    <div className="row mb-4">
      <div className="col-sm-12">
        <span className="F-size14">Conversation Between: </span>

        {allConversationParticipants?.filter((data) => data?.recipient_id === userContext?.firmDetails?.current_user)?.length > 0 && (
          <Link
            style={{ marginLeft: '0.5rem' }}
            className="F-size14 text-primary-dark text-decoration-none case-details-link pointer"
            to={() => handleModuleRedirectionForCurrentUser()}
          >
            You{', '}
          </Link>
        )}

        {allConversationParticipants
          ?.filter((data) => data?.recipient_id !== userContext.firmDetails?.current_user && data?.firm_user_id)
          .slice(0, 2) // Display only the first 2 recipients
          .map((msg, index) => (
            <Link
              key={index}
              className="F-size14 text-primary-dark text-decoration-none case-details-link pointer class-tooltip"
              to={() => handleModuleRedirection(msg, 'user')}
            >
              <i className="fas fa-user-tie me-2"></i>
              {msg?.first_name} {msg?.last_name} ({msg?.access_level && msg?.access_level})
              {index <
              allConversationParticipants?.filter(
                (data) => data?.recipient_id !== userContext?.firmDetails?.current_user && data?.firm_user_id
              )?.length -
                1
                ? ', '
                : ''}
              {msg.status === 'ARCHIVED' && (
                <Tooltip
                  position="top"
                  target=".class-tooltip"
                  content={msg?.status?.toLowerCase()?.charAt(0)?.toUpperCase() + msg?.status?.slice(1)?.toLowerCase()}
                />
              )}
            </Link>
          ))}

        {allConversationParticipants?.filter((data) => data?.recipient_id !== userContext.firmDetails.current_user && data?.firm_user_id)
          .length > 2 && (
          <span className="F-size14 text-primary-dark">
            {remainingFirmUsers?.length > 0 && (
              <Button
                className={`p-mr-2 pa-tags more-tag-button firm-users-more-button`}
                label={`+${remainingFirmUsers.length} members`}
                onClick={handleMoreClick}
              />
            )}
          </span>
        )}

        {/* OverlayPanel for remaining members */}
        <OverlayPanel ref={op} className="attorney-overlay">
          <div className="attorney-card-content case-report-group">
            {remainingFirmUsers?.map((msg, index) => (
              <div key={index} className="p-mb-2">
                <Link
                  className="F-size14 text-primary-dark text-decoration-none case-details-link pointer class-tooltip"
                  to={() => handleModuleRedirection(msg, 'user')}
                >
                  <i className="fas fa-user-tie me-2"></i>
                  {msg?.first_name} {msg?.last_name} ({msg?.access_level && msg?.access_level})
                  {msg.status === 'ARCHIVED' && (
                    <Tooltip
                      position="top"
                      target=".class-tooltip"
                      content={msg?.status?.toLowerCase()?.charAt(0)?.toUpperCase() + msg?.status?.slice(1)?.toLowerCase()}
                    />
                  )}
                </Link>
              </div>
            ))}
          </div>
        </OverlayPanel>
      </div>
    </div>
  );
}

export default ConversationBetween;
